<template>
    <div class="markers" :style="styles" v-if="collection?.data">
        <button class="btn-close float-end" @click="emit('closed')"></button>
        <button
            class="btn btn-link btn-add btn-primary border-primary w-100 d-flex align-items-center"
            :class="loading ? 'justify-content-between' : ''"
            @click="addIcon"
            >
            <span v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span v-if="loading" class="" role="status">Adding...</span>

            <svg
                v-if="!loading"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                width="18"
                height="18"
                class="me-3"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                />
            </svg>
            <span v-if="!loading">Marker</span>
        </button>
        <ul class="mt-4 icon-list">
            <li v-for="marker in collection?.data?.markers"
                :key="marker.id"
                class="d-flex justify-content-between align-items-center mt-3"
            >
                <div>
                    <img :src="marker.icon.url" width="32px" alt="" class="img img-thumbnail">
                    <span class="ms-3">{{ marker.label }}</span>
                </div>
                <div class="d-flex text-danger" @click="remove(marker)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="12" height="12">
                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                    </svg>
                </div>
            </li>
        </ul>
    </div>
    <div v-else-if="!collection">
        Waiting for data...
    </div>
</template>

<script setup>
    import { ref, watch, inject, reactive } from 'vue'
    const props = defineProps(["styles", "collection", "marker"]);
    let notyf = inject('notyf')

    const collection = reactive(props.collection);
    const loading = ref(false)

    const emit = defineEmits(['added', 'closed']);


    function addIcon(e) {
        e.preventDefault();

        loading.value = true

        axios.patch(`/collections/${props?.collection?.data?.id}`, {
            icon: props?.marker?.publicId,
        })
        .then(response => {
            collection.data = response.data.data
            loading.value = false
            notyf.success('Adding Icon Successful');
        })
        .catch(error => {
            console.error(error)
            loading.value = false
        });

        emit('added');
    }

    function remove(marker) {
        axios.delete(`/collections/${props?.collection?.data?.id}/${marker.id}`)
            .then(response => {
                notyf.success('removed from collection')
            })
            .catch(error => {
                console.error(error)
            })
        // remove the marker and post back to collections to drop it
    }

</script>

<style lang="scss" scoped>
    .markers{
    width: 100%;
    max-width: 300px;
    position: absolute;
    top: 0;
    left: 0;
    background: white;
    color: #222222;
    padding: 6px;
    font-size: 90%;
    // z-index: -1;
}

.btn-add {
    border: 1px dashed;
}

.icon-list {
    list-style: none;
    max-height: 300px;
    overflow: scroll;
}
</style>
